//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VillageManagement",
};
